export default "__VITE_ASSET__DtmLYQxj__"